import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ClientesListComponent } from './clientes-list/clientes-list.component';
import { ClientesCreateComponent } from './clientes-create/clientes-create.component';



const routes: Routes = [

    { path: '', component: ClientesListComponent  },
    { path: 'edit/:id', component: ClientesCreateComponent },
    { path: 'crear', component: ClientesCreateComponent }, 
    
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AppClientesRoutingModule {}